/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class PsSetItemDtEditor extends Serenity.Extensions.GridEditorBase<PsSetItemDtRow> {
        protected getColumnsKey() { return "Product.PsSetItemDt"; }
        protected getDialogType() { return PsSetItemDtDialog; }
        protected getLocalTextPrefix() { return PsSetItemDtRow.localTextPrefix; }

        public qnNo: number;
        public myPassValue: string;
        private _orderNo: string
        
        constructor(container: JQuery) {
            super(container);
        
        }
      
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text(" สร้างรายการ"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {
                        this.createEntityDialog(this.getItemType(), dlg => {


                            var dialog = dlg as PsSetItemDtDialog;
                            dialog.onSave = (opt, callback) => this.save(opt, callback);
                            var entity = this.getNewEntity() as PsSetItemDtRow;

                            entity.SetItemCode = this.myPassValue;
                            dialog.loadEntityAndOpenDialog(entity, false);
                        });
                    },
                }
            );

            // buttons.push({
            //     title: Q.text("Cal-Auto"),
            //     cssClass: 'am-approved-button',
            //     icon: 'fa-check-circle-o text-green',
            //     onClick: () => {
            //         if (!this.validateBeforeSave())
            //             return;
    
            //             Q.confirm(
            //                 "This Appoved Adjust Stock " + this.form.SetItemCode.value,
            //                 async () => {
            //                     var id = PsSetItemDtRow.getLookup().itemById[this.form.SetItemCode.value];
            //                     //id.ApprovedFlg = 1;
            //                     id.SetUnitPrice = this.form.SetPrice.value;
            //                     //id.UserApproved = Authorization.userDefinition.Username;
            //                     PsSetItemDtService.Update({ Entity: id }, (r) => {
            //                         this.dialogClose()
            //                     });
            //                     Q.notifySuccess("Cal Auto Success!");
            //                 });
            //     }
            // });

            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }
        // validateEntity(row, id) {
            
        //     row.PurUnitPrice = (row.CostValue || 0) / (row.Qty || 1);
        //     row.UnitCost = (row.CostValue || 0 ) / ((row.Qty || 1) * (row.PurUnitRatio));
            

        //     return true;
        // }
   
        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    new Slick.Aggregators.Sum('NormalUnitPrice'),
                    
                    new Slick.Aggregators.Sum('SetUnitPrice')
                ]
            });
           
            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected usePager() {
            return false;
        }

        public get OrderNo(): string { return this._orderNo; }

        // set OrderNo(value: string){
        // if(this._orderNo != value){
        //     this.clearDataGrid();
        //     var row =  PsSetItemDtRow.getLookup().items.filter(x => x.OrderNo == value)
        //     var i = 0;
        //     for (var po of row){
        //         i++;
        //         var item = <PsSetItemDtRow>{
        //             LineNo: i,
        //             ProdId: po.ProdId,
        //             ProdCode: ProductRow.getLookup().itemById[po.ProdId].ProdCode,
        //             Description: po.Description,
        //             UomId: po.UomId,
        //             UomCode: ProductUomRow.getLookup().itemById[po.UomId].UomName,
        //             UnitPrice: po.UnitPrice,
        //             OrderQty: po.OrderQty,
        //             Qty: null,
        //             NetPrice: po.NetPrice,
        //             ItemRemark: po.ItemRemark
        //         };
        //         var id = this.getNextId();
        //         //console.log("get id: " + this.getIdProperty());
        //         item[this.getIdProperty()]= id;
        //         this.view.addItem(item);
        //     }
        //     this.refresh();
        // }
    // }
    public clearDataGrid(){
        this.view.setItems([],true);
    }


    }
}

